import React, { useState, useRef } from 'react';
import Button from '@material-ui/core/Button';
import { Theme, useMediaQuery } from '@material-ui/core';

import DeviceSelectionDialog from '../../../DeviceSelectionDialog/DeviceSelectionDialog';
import SettingsIcon from '../../../../icons/SettingsIcon';
import { useIntl } from 'react-intl';

export default function SettingsMenu({ mobileButtonClass }: { mobileButtonClass?: string }) {
  const { formatMessage } = useIntl();

  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const [deviceSettingsOpen, setDeviceSettingsOpen] = useState(false);

  const anchorRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Button
        ref={anchorRef}
        onClick={() => setDeviceSettingsOpen(true)}
        startIcon={<SettingsIcon />}
        className={isMobile ? mobileButtonClass : ''}
      >
        {isMobile
          ? formatMessage({ id: 'settings' })
          : formatMessage({ id: 'device_selection_screen.device_settings' })}
      </Button>
      <DeviceSelectionDialog open={deviceSettingsOpen} onClose={() => setDeviceSettingsOpen(false)} />
    </>
  );
}
